import React from 'react';
import {
    Box,
    Button,
    Container,
    Grid,
    Typography,
    useTheme,
    alpha,
    Paper,
    Avatar,
    Chip,
    Divider,
    Stack
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
    RocketLaunch as RocketIcon,
    Groups as TeamIcon,
    Public as GlobalIcon,
    EmojiEvents as AchievementIcon,
    DesignServices as DesignIcon,
    PhoneAndroid as MobileIcon,
    Search as SeoIcon,
    TrendingUp as GrowthIcon,
    Verified as QualityIcon
} from '@mui/icons-material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AboutUsVector from '../../../assets/other/20943566.jpg';
import TeamCollaboration from '../../../assets/other/collaboration.png';
import GlobalPresence from '../../../assets/other/global-presence.png';

const AboutUsPage = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const stats = [
        { value: "15+", label: "Years Experience", icon: <AchievementIcon fontSize="large" /> },
        { value: "500+", label: "Projects Completed", icon: <DesignIcon fontSize="large" /> },
        { value: "4", label: "Countries Served", icon: <GlobalIcon fontSize="large" /> },
        { value: "98%", label: "Client Satisfaction", icon: <QualityIcon fontSize="large" /> }
    ];

    const services = [
        { title: "Web Development", icon: <DesignIcon />, color: theme.palette.primary.main },
        { title: "Mobile Apps", icon: <MobileIcon />, color: theme.palette.secondary.main },
        { title: "Digital Marketing", icon: <SeoIcon />, color: theme.palette.success.main },
        { title: "Business Growth", icon: <GrowthIcon />, color: theme.palette.warning.main }
    ];

    return (
        <Box sx={{ bgcolor: 'background.default' }}>
            {/* Hero Section */}
            <Box sx={{ bgcolor: 'background.default' }}>
                {/* Hero Section */}
                <Box
                    sx={{
                        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0.9)} 0%, ${alpha(theme.palette.secondary.dark, 0.9)} 100%)`,
                        color: 'common.white',
                        py: 10,
                        position: 'relative',
                        overflow: 'hidden'
                    }}
                >
                    <Container maxWidth="lg">
                        <Grid container spacing={4} alignItems="center">
                            {/* Text Section */}
                            <Grid item xs={12} md={6}>
                                <Stack spacing={4}>
                                    <Chip
                                        onClick={() => console.log(" ")}
                                        label="Innovation & Excellence"
                                        icon={<RocketIcon />}
                                        sx={{
                                            bgcolor: alpha(theme.palette.common.white, 0.2),
                                            color: 'common.white',
                                            px: 2,
                                            py: 1,
                                            fontSize: '0.875rem',
                                            width: 'fit-content'
                                        }}
                                    />

                                    <Typography
                                        variant="h2"
                                        component="h1"
                                        sx={{
                                            fontWeight: 800,
                                            fontSize: { xs: '2.5rem', md: '3.5rem' },
                                            lineHeight: 1.2
                                        }}
                                    >
                                        About <Box component="span" sx={{ color: theme.palette.warning.light }}>ShreeshTech</Box>
                                    </Typography>

                                    <Typography variant="h6" sx={{ opacity: 0.9, fontWeight: 400 }}>
                                        Conceived by industry veterans, we're your destination for comprehensive technical and digital marketing solutions.
                                    </Typography>

                                    <Button
                                        variant="contained"
                                        color="warning"
                                        onClick={() => navigate('/services')}
                                        endIcon={<ArrowForwardIcon />}
                                        sx={{
                                            px: 4,
                                            py: 1.5,
                                            fontSize: '1rem',
                                            fontWeight: 600,
                                            width: 'fit-content',
                                            '&:hover': {
                                                transform: 'translateY(-2px)'
                                            }
                                        }}
                                    >
                                        Explore Our Services
                                    </Button>
                                </Stack>
                            </Grid>

                            {/* Image Section */}
                            {/* <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            component="img"
            src={AboutUsVector}
            alt="About ShreeshTech"
            sx={{
              width: '100%',
              maxWidth: 500,
              height: 'auto',
              animation: 'float 6s ease-in-out infinite'
            }}
          />
        </Grid> */}
                        </Grid>
                    </Container>
                </Box>
            </Box>

            {/* Company Overview */}
            <Container maxWidth="lg" sx={{ py: 10 }}>
                <Grid container spacing={6} alignItems="center">
                    <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                        <Box
                            component="img"
                            src={TeamCollaboration}
                            alt="Team Collaboration"
                            sx={{
                                width: '100%',
                                maxWidth: 500,
                                height: 'auto',
                                borderRadius: 2,
                                boxShadow: theme.shadows[10]
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
                        <Stack spacing={3}>
                            <Typography variant="h4" component="h2" sx={{ fontWeight: 700 }}>
                                An innovative and proactive company
                            </Typography>

                            <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.1rem' }}>
                                We are a dynamic team of highly skilled individuals united by our shared passion for our work. Our unwavering belief in the power of creativity and forward thinking is evident in every project we undertake.
                            </Typography>

                            <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.1rem' }}>
                                With over 15 years of experience, our diverse clientele includes businesses from India, UAE, Australia, and worldwide, spanning both private and public sectors.
                            </Typography>

                            <Divider sx={{ my: 2 }} />

                            <Box display="flex" justifyContent="center">
                                <Grid container spacing={2} justifyContent="center" sx={{ maxWidth: '1200px' }}>
                                    {stats.map((stat, index) => (
                                        <Grid item xs={6} sm={6} md={3} key={index}>
                                            <Paper
                                                elevation={3}
                                                sx={{
                                                    p: 3,
                                                    borderRadius: 3,
                                                    height: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    textAlign: 'center',
                                                    transition: 'all 0.3s ease',
                                                    '&:hover': {
                                                        transform: 'translateY(-5px)',
                                                        boxShadow: theme.shadows[6]
                                                    }
                                                }}
                                            >
                                                <Box sx={{ color: theme.palette.primary.main, mb: 1 }}>
                                                    {stat.icon}
                                                </Box>
                                                <Typography variant="h5" component="div" sx={{ fontWeight: 700 }}>
                                                    {stat.value}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {stat.label}
                                                </Typography>
                                            </Paper>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>

                        </Stack>
                    </Grid>
                </Grid>
            </Container>

            {/* Mission Section */}
            <Box sx={{
                bgcolor: 'grey.50',
                py: 10,
                backgroundImage: 'radial-gradient(circle at 10% 20%, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0) 100%)'
            }}>
                <Container maxWidth="lg">
                    <Grid container spacing={6} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Stack spacing={3}>
                                <Typography variant="h4" component="h2" sx={{ fontWeight: 700 }}>
                                    Our Mission
                                </Typography>

                                <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.1rem' }}>
                                    At ShreeshTech our main goal is to deliver the highest quality service to all of our clients.
                                </Typography>

                                <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.1rem' }}>
                                    Crafting tailored strategies aligned with client needs and providing comprehensive support throughout the process, we're your steadfast partner in the quest for business growth.
                                </Typography>

                                <Box sx={{ mt: 3 }}>
                                    {services.map((service, index) => (
                                        <Chip
                                            onClick={() => console.log(" ")}
                                            key={index}
                                            icon={service.icon}
                                            label={service.title}
                                            sx={{
                                                m: 1,
                                                px: 2,
                                                py: 1.5,
                                                bgcolor: alpha(service.color, 0.1),
                                                color: service.color,
                                                fontWeight: 600,
                                                '& .MuiChip-icon': {
                                                    color: service.color
                                                }
                                            }}
                                        />
                                    ))}
                                </Box>
                            </Stack>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Paper
                                elevation={6}
                                sx={{
                                    p: 4,
                                    borderRadius: 3,
                                    background: `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.1)} 0%, ${alpha(
                                        theme.palette.secondary.light,
                                        0.1
                                    )} 100%)`,
                                    position: 'relative',
                                    overflow: 'hidden',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: -50,
                                        right: -50,
                                        width: 200,
                                        height: 200,
                                        borderRadius: '50%',
                                        background: alpha(theme.palette.primary.main, 0.1)
                                    }
                                }}
                            >
                                <Typography variant="h5" component="h3" sx={{ fontWeight: 600, mb: 3 }}>
                                    Our Expertise
                                </Typography>

                                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                                    Be it web design, mobile app development, or search engine marketing, our team of experts possesses the expertise to amplify your business, streamline expenses, mitigate risks, and enhance overall efficiency.
                                </Typography>

                                <Box
                                    component="img"
                                    src={GlobalPresence}
                                    alt="Global Presence"
                                    sx={{
                                        width: '100%',
                                        height: 'auto',
                                        maxHeight: 250,
                                        mt: 2
                                    }}
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {/* Team CTA */}
            <Container maxWidth="lg" sx={{ py: 10, textAlign: 'center' }}>
                <Paper
                    elevation={3}
                    sx={{
                        p: 6,
                        borderRadius: 4,
                        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.1)} 0%, ${alpha(
                            theme.palette.secondary.light,
                            0.1
                        )} 100%)`,
                        position: 'relative',
                        overflow: 'hidden'
                    }}
                >
                    <Typography variant="h4" component="h2" sx={{ fontWeight: 700, mb: 3 }}>
                        Ready to Transform Your Business?
                    </Typography>

                    <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 700, mx: 'auto', mb: 4 }}>
                        Our team of experts is ready to help you achieve your business goals with cutting-edge technology and innovative solutions.
                    </Typography>

                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={() => navigate('/get-in-touch')}
                        endIcon={<ArrowForwardIcon />}
                        sx={{
                            px: 6,
                            py: 1.5,
                            fontSize: '1rem',
                            fontWeight: 600,
                            '&:hover': {
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        Get in Touch
                    </Button>
                </Paper>
            </Container>
        </Box>
    );
};

export default AboutUsPage;